
  class PredictiveSearch extends HTMLElement {
    constructor() {
      super();

      this.input = this.querySelector('input[type="search"]');
      this.predictiveSearchResults = this.querySelector('#shopify-section-predictive-search');
      this.viewAllBtn = document.getElementById('predictive_view_all_btn');
      this.input.addEventListener(
        'input',
        this.debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }

    onChange() {
      const searchTerm = this.input.value.trim();

      if (!searchTerm.length) {
        this.close();
        return;
      }

      this.getSearchResults(searchTerm);
    }

    getSearchResults(searchTerm) {
      fetch(
        `${routes.predictive_search_url}?q=${searchTerm}&resources[limit]=10&resources[type]=product,article,collection&resources[options[unavailable_products]]=last&resources[options[fields]]=title,body,product_type,variants.title,variants.sku,vendor&section_id=predictive-search`
      )
        .then((response) => {
          if (!response.ok) {
            var error = new Error(response.status);
            this.close();
            throw error;
          }

          return response.text();
        })
        .then((text) => {
          const resultsMarkup = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#shopify-section-predictive-search').innerHTML;
          this.predictiveSearchResults.innerHTML = resultsMarkup;
          this.open();
        })
        .catch((error) => {
          this.close();
          throw error;
        });
    }
    open() {
      this.predictiveSearchResults.style.display = 'block';
      this.viewAllBtn.style.display = 'block';
    }

    close() {
      this.predictiveSearchResults.style.display = 'none';
      this.viewAllBtn.style.display = 'none';
    }

    debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }
  }

  customElements.define('predictive-search', PredictiveSearch);
